<picture [class]="class">
    <source srcset="{{ gameLogo.normal_url }}, {{ gameLogo.retina_url }} 1.5x">
    <img [src]="gameLogo.normal_url" alt="logo">
</picture>
